import Event from '../event';

export function waitOnline(): Promise<void>
{
	return new Promise((resolve) => {
		if (navigator.onLine)
		{
			resolve();
		}
		else
		{
			Event.bindOnce(window, 'online', () => resolve());
		}
	});
}
